import React from 'react';
import type { Board } from './PluginHeaderButton.types';

import { renderComponent } from 'app/src/components/ComponentWrapper';
import { PluginHeaderHubButton } from './PluginHeaderHubButton';

export const renderPluginDropdownList = (
  container: Element,
  board: Board,
  openEnabled: () => object,
  openDirectory: () => object,
  openPluginSettings: () => object,
) => {
  if (!container) {
    return;
  }

  return renderComponent(
    React.createElement(PluginHeaderHubButton, {
      container: container,
      board: board,
      openEnabled: openEnabled,
      openDirectory: openDirectory,
      openPluginSettings: openPluginSettings,
    }),
    container,
  );
};
